/** CUSTOM Component to override get key from scanned 
 *
 * @param {string} qrString
 * @returns {string}
 * @private
 */

export const _getKey = (qrString) => {
    let urlWithoutId = qrString.substring(0, qrString.lastIndexOf('/'));
    let startOfKey = 0;

    if (qrString.includes("stockmovement")) {
        startOfKey = urlWithoutId.indexOf("stockmovement");
    }
    else {
        startOfKey = urlWithoutId.lastIndexOf('/') + 1;
    }

    return urlWithoutId.substring(startOfKey);
}